function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12z",
  fill: "#00a4b9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 19h10c.553 0 1-.448 1-1s-.447-1-1-1h-10c-.553 0-1 .448-1 1s.447 1 1 1z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.47 14.78c.146.147.338.22.53.22s.384-.073.53-.22l3.25-3.25c.472-.47.139-1.28-.53-1.28h-2.25v-4.5c0-.552-.447-1-1-1s-1 .448-1 1v4.5h-2.25c-.669 0-1.002.81-.53 1.28z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12v-5h-5c-.553 0-1-.448-1-1s.447-1 1-1h5v-2c-.192 0-.384-.073-.53-.22l-3.25-3.25c-.472-.47-.139-1.28.53-1.28h2.25v-4.5c0-.552.447-1 1-1z",
  fill: "#00a4b9"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 17h-5c-.553 0-1 .448-1 1s.447 1 1 1h5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 4.75c-.553 0-1 .448-1 1v4.5h-2.25c-.669 0-1.002.81-.53 1.28l3.25 3.25c.146.147.338.22.53.22z"
})));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 40,
    viewBox: "0 0 24 24",
    width: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.28778728.svg";
export { ForwardRef as ReactComponent };